import { render, staticRenderFns } from "./dangerJournalItem.vue?vue&type=template&id=7103e27e"
import script from "./dangerJournalItem.vue?vue&type=script&lang=js"
export * from "./dangerJournalItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7103e27e')) {
      api.createRecord('7103e27e', component.options)
    } else {
      api.reload('7103e27e', component.options)
    }
    module.hot.accept("./dangerJournalItem.vue?vue&type=template&id=7103e27e", function () {
      api.rerender('7103e27e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/env/danger/dangerJournalItem.vue"
export default component.exports